import EmployeeFund from "../components/EmployeeFund";
import useEmployeeFund from "../hook/useEmployeeFund";

const EmployeeFundPage = () => {
  const employeeFundProps = useEmployeeFund();
  return <EmployeeFund {...employeeFundProps} />;
};

export default EmployeeFundPage;
